import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrButton, { SR_BUTTON_THEME_ADOBE_GREEN, SR_BUTTON_HEIGHT_MEDIUM } from 'client/components/SrButton/SrButton';

const SrFooterButton = ({
  hasBoxShadow,
  disabled,
  onClick,
  children,
  type,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrButton
      theme={SR_BUTTON_THEME_ADOBE_GREEN}
      minWidth={isSmallScreen ? '100%' : '130px'}
      heightType={SR_BUTTON_HEIGHT_MEDIUM}
      type={type}
      hasBoxShadow={hasBoxShadow}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </SrButton>
  );
};

SrFooterButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string,
};

SrFooterButton.defaultProps = {
  type: 'submit',
};

SrFooterButton.displayName = 'SrFooterButton';

export default SrFooterButton;
